import React from 'react';
import TruncatedText from '../../../components/common/TruncatedText';
import './SidePanelTab.css';

interface SidePanelTabProps {
  label: string;
  isActive: boolean;
  basis: string;
  onClick: () => void;
  className?: string;
}

const SidePanelTab: React.FC<SidePanelTabProps> = ({ 
  label, 
  isActive, 
  basis, 
  onClick,
  className = ''
}) => {
  return (
    <button
      className={`side-panel-tab ${isActive ? 'side-panel-tab--active' : 'side-panel-tab--inactive'} ${className}`}
      style={{ 
        flexBasis: basis, 
        flexGrow: 0, 
        flexShrink: 1,
        minWidth: '0'
      }}
      onClick={onClick}
    >
      <TruncatedText
        text={label}
        className="side-panel-tab__text text-xs"
        placement="top"
      />
    </button>
  );
};

export default SidePanelTab;
